import { defaultAxios } from '@/services';

const okendoService = {
  async createOkendoItem(
    user_name: string,
    user_password: string,
    workspaceAlias: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/okendo/credential`,
        {
          user_name: user_name,
          user_password: user_password,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getOkendoItem(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/okendo/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteOkendoInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/okendo/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(`/okendo/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default okendoService;
